import { Controller } from "@hotwired/stimulus";

// Double-click a tab's name to rename it, the way every tabbed thing does.
// Enter or clicking away commits, Escape puts it back.
//
// Only the tab you're already on carries a form (see kit/_header), so a
// double-click can never race a navigation: the current tab's title is a span,
// not a link.
export default class extends Controller {
  static targets = ["label", "form", "input"];

  start(event) {
    if (!this.hasFormTarget) return;
    event.preventDefault();

    this.original = this.inputTarget.value;
    this.element.classList.add("kit-tab--renaming");
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  // Clicking away keeps what you typed — the same as renaming a file.
  commit() {
    if (!this.hasFormTarget || !this.renaming) return;
    if (this.inputTarget.value.trim() === (this.original || "").trim()) {
      this.cancel();
      return;
    }
    this.formTarget.requestSubmit();
  }

  cancel() {
    if (!this.hasFormTarget) return;
    this.inputTarget.value = this.original || "";
    this.element.classList.remove("kit-tab--renaming");
  }

  get renaming() {
    return this.element.classList.contains("kit-tab--renaming");
  }
}
